import { configureIguazu } from 'iguazu';
import debounce from 'lodash/debounce';

const config = () => {
  configureIguazu({
    stateChangeLimiter: (onStateChange) => debounce(onStateChange, 100),
  });
};

export default config;
